import _extends from "reshow-runtime/es/helpers/extends";
import _objectWithoutProperties from "reshow-runtime/es/helpers/objectWithoutProperties";
import _classCallCheck from "reshow-runtime/es/helpers/classCallCheck";
import _createClass from "reshow-runtime/es/helpers/createClass";
import _assertThisInitialized from "reshow-runtime/es/helpers/assertThisInitialized";
import _possibleConstructorReturn from "reshow-runtime/es/helpers/possibleConstructorReturn";
import _getPrototypeOf from "reshow-runtime/es/helpers/getPrototypeOf";
import _inherits from "reshow-runtime/es/helpers/inherits";
import _defineProperty from "reshow-runtime/es/helpers/defineProperty";

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { SemanticUI } from 'react-atomic-molecule';

var CarouselSwipe = /*#__PURE__*/function (_Component) {
  _inherits(CarouselSwipe, _Component);

  var _super = _createSuper(CarouselSwipe);

  function CarouselSwipe() {
    var _this;

    _classCallCheck(this, CarouselSwipe);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "dragging", false);

    _defineProperty(_assertThisInitialized(_this), "startX", null);

    _defineProperty(_assertThisInitialized(_this), "swipeStart", function (e) {
      _this.dragging = true;
      _this.startX = _this.getX(e);
    });

    _defineProperty(_assertThisInitialized(_this), "swipeMove", function (e) {
      if (!_this.dragging) {
        return false;
      }

      var posX = _this.getX(e);

      var move = _this.startX - posX;
    });

    _defineProperty(_assertThisInitialized(_this), "swipeEnd", function (e) {});

    return _this;
  }

  _createClass(CarouselSwipe, [{
    key: "getX",
    value: function getX(e) {
      var posX = e.touches !== undefined ? e.touches[0].pageX : e.clientX;
      return posX;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var height = this.el.offsetHeight;
      var onHeight = this.props.onHeight;

      if (onHeight) {
        onHeight(height);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          onHeight = _this$props.onHeight,
          others = _objectWithoutProperties(_this$props, ["onHeight"]);

      return /*#__PURE__*/React.createElement(SemanticUI, {
        style: Styles.container
      }, /*#__PURE__*/React.createElement(SemanticUI, _extends({
        className: "carousel-swipe",
        style: Styles.inside
      }, others, {
        refCb: function refCb(el) {
          return _this2.el = el;
        },
        onMouseDown: this.swipeStart,
        onMouseMove: this.swipeMove,
        onMouseUp: this.swipeEnd,
        onMouseLeave: this.swipeMove,
        onTouchStart: this.swipeStart,
        onTouchMove: this.swipeMove,
        onTouchEnd: this.swipeEnd,
        onTouchCancel: this.swipeMove
      })));
    }
  }]);

  return CarouselSwipe;
}(Component);

export default CarouselSwipe;
var Styles = {
  container: {
    overflowX: 'scroll',
    overflowY: 'hidden',
    position: 'relative',
    paddingBottom: 5,
    fontSize: '1rem'
  },
  inside: {
    display: 'inline-block',
    position: 'relative',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  }
};